import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-tecno1-sidebar',
  templateUrl: './tecno1-sidebar.component.html',
  styleUrls: ['./tecno1-sidebar.component.css']
})
export class Tecno1SidebarComponent implements OnInit {

  @Input()
  data: any = null;
  
  @Input()
  planSeleccionado: any = null;

  @Input()
  editData: boolean = false;

  @Input()
  editPlan: boolean = false;

  @Output()
  changeData: EventEmitter<any>;
 
  @Output()
  changePlan: EventEmitter<any>;
  
  errors: any = [];

  constructor(private api: ApiService) { 
    this.changeData = new EventEmitter();
    this.changePlan = new EventEmitter();
  }

  ngOnInit() {
  }

  doChangePlan() {
    this.changePlan.emit();
  }
  doChangeData() {
    this.changeData.emit({newData: this.data});
  }


  updateLead() {
    this.api.updateLead(this.data).subscribe(ret => {

      if (ret.status == "ok") {
        this.errors = [];
        this.data = ret.data;
      }

      if (ret.status == "error") {
        this.errors = ret.errors;
      }

    }, err => {
      alert("Se ha producido un error");
    });

  }


}
